/**
 * Code 128 (code set B) as SVG geometry, for sample-tube labels. Accession numbers are ASCII, so set B covers them.
 * Each pattern lists bar/space widths in modules (bar first). Values 0–102 are symbols, 103–105 start codes, 106 stop.
 */
export const CODE128 = ("212222 222122 222221 121223 121322 131222 122213 122312 132212 221213 221312 231212 112232 122132 122231 113222 123122 123221 223211 221132 " +
  "221231 213212 223112 312131 311222 321122 321221 312212 322112 322211 212123 212321 232121 111323 131123 131321 112313 132113 132311 211313 " +
  "231113 231311 112133 112331 132131 113123 113321 133121 313121 211331 231131 213113 213311 213131 311123 311321 331121 312113 312311 332111 " +
  "314111 221411 431111 111224 111422 121124 121421 141122 141221 112214 112412 122114 122411 142112 142211 241211 221114 413111 241112 134111 " +
  "111242 121142 121241 114212 124112 124211 411212 421112 421211 212141 214121 412121 111143 111341 131141 114113 114311 411113 411311 113141 " +
  "114131 311141 411131 211412 211214 211232 2331112").split(" ");

/** Symbol values for text in code set B, with start (104), checksum and stop (106). */
export function code128Values(text: string): number[] {
  if (!/^[\x20-\x7e]{1,40}$/.test(text)) throw new Error("Code 128B: printable ASCII, 1–40 characters");
  const data = [...text].map((c) => c.charCodeAt(0) - 32);
  const check = (104 + data.reduce((s, v, i) => s + v * (i + 1), 0)) % 103;
  return [104, ...data, check, 106];
}
/** Bars as [x, width] in modules, with a 10-module quiet zone on both sides. */
export function code128Bars(text: string): { bars: [number, number][]; width: number } {
  const bars: [number, number][] = [];
  let x = 10;
  for (const v of code128Values(text)) {
    const w = CODE128[v]!;
    for (let i = 0; i < w.length; i++) { const n = Number(w[i]); if (i % 2 === 0) bars.push([x, n]); x += n; }
  }
  return { bars, width: x + 10 };
}
